export default __webpack_public_path__ + "static/media/baseline-battery_charging_full-24px.f32c99f4.svg";